export enum WeightUnit {
  LB = 'LB',
  KG = 'KG',
}

export enum TypeBagsWeight {
  _10KG = 1,
  _15KG,
  _20KG,
  _25KG,
  _32KG,
}

export enum BagsWeightCode {
  '15KG' = '07X',
  '20KG' = '0LX,0JH,0LL,02T,XB5,XB6,XB7',
  '25KG' = '0IA,0CD,0CE,0CF,0CG,0CH,0CI',
}

export enum BagsWeightForWeight {
  '10KG' = '10',
  '15KG' = '15',
  '20KG' = '20',
  '25KG' = '25',
  '32KG' = '32',
}

export enum StatusBag {
  NONE = 'NONE',
  INCLUDE = 'include',
  REDEEMED = 'redeemed',
  REDEEMED_APPLIED = 'redeemedApplied',
  PAID = 'paid',
  TO_PAY = 'toPay',
  DOCUMENT = 'Document',
  ON_HOLD = 'onhold',
}

export enum StatusBagCarryOn {
  NONE = 0,
  USED = 1,
  USED_WITHOUT_WEIGHT = 2,
}

export enum ResultModalRedeem {
  SUCCESS,
  NO_REDEEM,
  ERROR,
}

export enum BagCommercialName {
  CARRY_ON_15KG = 'CARRY ON UP TO 15KG',
}

export enum DocumentationWindowPhase {
  BEFORE_OPEN = 'BEFORE_OPEN',
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}
